// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "leaflet/dist/leaflet.css";
import "react-toastify/dist/ReactToastify.css";
import { GlobalCountProvider } from "./context/GlobalCountContext";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import CustomThemeProvider from "./components/Layout/ThemeProvider";
import PortraitOnlyOverlay from "./components/PortraitOnlyOverlay";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GlobalCountProvider>
    <App />
  </GlobalCountProvider>
);

const portraitRoot = document.getElementById("portrait-only-root");
if (portraitRoot) {
  const portraitReactRoot = ReactDOM.createRoot(portraitRoot);
  portraitReactRoot.render(
    <CustomThemeProvider>
      <PortraitOnlyOverlay />
    </CustomThemeProvider>
  );
}

reportWebVitals();

// Register service worker for PWA
serviceWorkerRegistration.register();


